// Anthology: relabel Color swatch text based on the selected Metal tier.
// Display-only - does not touch the underlying option value used for variant
// matching/cart/checkout (data-value + the hidden <select> stay untouched).
(function ($) {
  var LABELS = {
    brass:    { GOLD: '14K Gold Plated', SILVER: '14K White Gold Plated', 'ROSE GOLD': '14K Rose Gold Plated' },
    sterling: { GOLD: '14K Gold Plated', SILVER: 'Silver',                'ROSE GOLD': '14K Rose Gold Plated' },
    gold14k:  { GOLD: '14K Yellow Gold', SILVER: '14K White Gold',        'ROSE GOLD': '14K Rose Gold' },
    gold10k:  { GOLD: '10K Yellow Gold', SILVER: '10K White Gold',        'ROSE GOLD': '10K Rose Gold' }
  };

  function metalTier(raw) {
    var v = (raw || '').toUpperCase();
    if (v.indexOf('BRASS') > -1) return 'brass';
    if (v.indexOf('STERLING') > -1) return 'sterling';
    if (v.indexOf('10K') > -1) return 'gold10k';
    if (v.indexOf('14K') > -1) return 'gold14k';
    return null;
  }

  function colorKey(raw) {
    var v = (raw || '').trim().toUpperCase();
    if (v.indexOf('ROSE') > -1) return 'ROSE GOLD';
    if (v === 'SILVER') return 'SILVER';
    if (v === 'GOLD') return 'GOLD';
    return null;
  }

  function relabel($form) {
    var $metalWrap = $form.find('[data-name="Base Metal"], [data-name="Material"], [data-name="Metal"]').first();
    var $colorWrap = $form.find('[data-name="Color"]').first();
    if (!$metalWrap.length || !$colorWrap.length) return;

    var $activeMetal = $metalWrap.find('.clickyboxes > li > a.active').first();
    if (!$activeMetal.length) $activeMetal = $metalWrap.find('.clickyboxes > li > a').first();
    var tier = metalTier($activeMetal.attr('data-value'));
    if (!tier) return; // unrecognized metal system (e.g. Tungsten) - leave labels as-is

    var map = LABELS[tier];
    $colorWrap.find('.clickyboxes > li > a[data-value]').each(function () {
      var $a = $(this);
      var key = colorKey($a.attr('data-value'));
      if (key && map[key]) {
        var current = $a.text().replace(/\s+/g, ' ').trim();
        if (current !== map[key]) $a.html(map[key]);
      }
    });
  }

  function initAll() {
    $('form[action="/cart/add"]').each(function () {
      var $form = $(this);
      if ($form.data('anthologyLabelsInit')) return;
      $form.data('anthologyLabelsInit', true);

      relabel($form);

      var observer = new MutationObserver(function () {
        relabel($form);
      });
      observer.observe($form[0], { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Catch forms rendered later (quick view modals, ajax re-renders, theme editor)
  document.addEventListener('shopify:section:load', initAll);
  setInterval(initAll, 1500);
})(jQuery);
